export default __webpack_public_path__ + "static/media/inside.ad58fd8d.png";